export let SignupDatapoint;

(function (SignupDatapoint) {
  SignupDatapoint["FirstName"] = "first_name";
  SignupDatapoint["LastName"] = "last_name";
  SignupDatapoint["CompanyName"] = "company_name";
  SignupDatapoint["CompanyDomain"] = "company_domain";
  SignupDatapoint["Email"] = "email";
})(SignupDatapoint || (SignupDatapoint = {}));